var map = {
	"./3d-graph-computer-illustration.jpg": 6985,
	"./Logo_agents.svg": 21676,
	"./Logo_auto.svg": 55847,
	"./Logo_core.svg": 81711,
	"./Logo_drug.svg": 99384,
	"./Logo_education.svg": 52408,
	"./Logo_energy.svg": 92102,
	"./Logo_finance.svg": 94572,
	"./Logo_genom.svg": 53008,
	"./Logo_graphen.svg": 55923,
	"./Logo_manufacture.svg": 14549,
	"./Logo_robotics.svg": 2185,
	"./Logo_security.svg": 30559,
	"./about/Ardi/NLP.jpg": 30499,
	"./about/Ardi/Reasoning.jpg": 22733,
	"./about/Ardi/Sense.jpg": 34736,
	"./about/Ardi/action1.jpg": 24710,
	"./about/Ardi/action2.jpg": 40561,
	"./about/Ardi/ai_analytics.png": 50882,
	"./about/Ardi/ai_cyber_4.jpg": 90124,
	"./about/Ardi/ai_explanation.png": 34091,
	"./about/Ardi/ai_finance_2.jpg": 50271,
	"./about/Ardi/ai_finance_3.jpg": 42210,
	"./about/Ardi/ai_finance_4.jpg": 27441,
	"./about/Ardi/ai_finance_front.jpg": 18084,
	"./about/Ardi/ai_learning.png": 16970,
	"./about/Ardi/ai_learning2.png": 1986,
	"./about/Ardi/ai_medical_3.jpg": 95809,
	"./about/Ardi/ai_pipeline.png": 1578,
	"./about/Ardi/ai_reasoning.png": 26094,
	"./about/Ardi/ardi_analytics.png": 8740,
	"./about/Ardi/ardi_components.jpg": 65574,
	"./about/Ardi/ardi_database.png": 69589,
	"./about/Ardi/ardi_database2.png": 18960,
	"./about/Ardi/ardi_kf_3.png": 59035,
	"./about/Ardi/brain-functions.png": 2933,
	"./about/Ardi/databaseuse.jpg": 99697,
	"./about/Ardi/emotion1.jpg": 8373,
	"./about/Ardi/emotion2.jpg": 67882,
	"./about/Ardi/emotion3.jpg": 80039,
	"./about/Ardi/emotion4.jpg": 25628,
	"./about/Ardi/fake-computer.jpg": 58637,
	"./about/Ardi/holistic.jpg": 91682,
	"./about/Ardi/knowledge1.png": 396,
	"./about/Ardi/knowledge2.jpg": 32631,
	"./about/Ardi/knowledge3.jpg": 68794,
	"./about/Ardi/knowledge4.jpg": 89481,
	"./about/Ardi/marketing.jpg": 23633,
	"./about/Ardi/person_sunglasses.jpg": 75837,
	"./about/Ardi/personality-gird.png": 78546,
	"./about/Ardi/personality1.jpg": 98044,
	"./about/Ardi/personality2.jpg": 82699,
	"./about/Ardi/personality4.jpg": 40277,
	"./about/Ardi/portfolio-3.jpg": 91029,
	"./about/Ardi/strategy.jpg": 74622,
	"./about/Ardi/strategy2.jpg": 50710,
	"./about/Ardi/videounderstanding.jpg": 47588,
	"./about/Ardi/workflow usecase.jpg": 85951,
	"./about/Ardi/workflow1.jpg": 29497,
	"./about/Ardi/workflow2.jpg": 14478,
	"./about/Atom/Atom_foundation.png": 38775,
	"./about/Atom/adme.png": 1705,
	"./about/Atom/antibody antigen affinity.png": 99440,
	"./about/Atom/antibody antigen contact.png": 71146,
	"./about/Atom/atom1.jpg": 70462,
	"./about/Atom/atom2.png": 64657,
	"./about/Atom/atomnetwork.jpg": 57985,
	"./about/Atom/atomoverview.png": 74994,
	"./about/Atom/diseaseprogress.png": 79857,
	"./about/Atom/diseaseriskeval.png": 43319,
	"./about/Atom/drug and target.png": 96986,
	"./about/Atom/drugresistance.png": 68793,
	"./about/Atom/functionprediction.png": 7987,
	"./about/Atom/genomevariantreasoning.png": 32521,
	"./about/Atom/modular interaction.png": 17928,
	"./about/Atom/molgan.png": 88858,
	"./about/Atom/multiomicsnetwork.png": 53242,
	"./about/Atom/mutationidentification.png": 82431,
	"./about/Atom/pathwaynetwork.png": 30796,
	"./about/Atom/pp co simulation.png": 4427,
	"./about/Atom/protein binding site.png": 96067,
	"./about/Atom/protein force field.png": 16178,
	"./about/Atom/protein function prediction.png": 50532,
	"./about/Atom/protein structure simulation.jpg": 54607,
	"./about/Atom/racedifference.png": 48378,
	"./about/Atom/singlecellanalysis.png": 34790,
	"./about/Atom/virus_graph.gif": 68847,
	"./about/aiPlatforms/agni3.png": 7727,
	"./about/aiPlatforms/ai_cyber_4.jpg": 62388,
	"./about/aiPlatforms/ai_finance_1.jpg": 4696,
	"./about/aiPlatforms/ai_finance_2.jpg": 37543,
	"./about/aiPlatforms/ai_finance_3.jpg": 25386,
	"./about/aiPlatforms/ai_finance_4.jpg": 11129,
	"./about/aiPlatforms/aicaimage1.png": 13559,
	"./about/aiPlatforms/aicaimage2.png": 12924,
	"./about/aiPlatforms/aicaimage3.png": 42341,
	"./about/aiPlatforms/aicaimage4.png": 57674,
	"./about/aiPlatforms/alice1.png": 19576,
	"./about/aiPlatforms/alice2.jpg": 91371,
	"./about/aiPlatforms/alice3.png": 43306,
	"./about/futuristic-business-scene.jpg": 24606,
	"./about/group-of-young-people.jpeg": 6761,
	"./about/group_pic.jpeg": 38567,
	"./about/technologies/ai_ardi_front.jpg": 76726,
	"./about/technologies/ai_cyber_front.jpg": 89315,
	"./about/technologies/alpha-finance.jpg": 82266,
	"./about/technologies/atom-med.jpg": 11805,
	"./about/technologies/carrepair.jpg": 166,
	"./about/technologies/energy1.jpg": 81618,
	"./about/technologies/glowing-blue-cyborg.jpg": 69284,
	"./astral-wallpapers.jpg": 22979,
	"./banner.jpg": 13088,
	"./blog/AMOS.png": 25563,
	"./blog/Atom_foundation.png": 13514,
	"./blog/ai-summit-22.jpeg": 2041,
	"./blog/aiBestFriend.jpg": 80528,
	"./blog/aiCompanion.jpg": 10695,
	"./blog/aiDumpling.png": 70543,
	"./blog/aiEvolution.jpg": 15594,
	"./blog/ardi-brain.png": 87620,
	"./blog/digital-daniel.png": 18727,
	"./blog/digitalDaniel.png": 11722,
	"./blog/finance_force_network.png": 3646,
	"./blog/genome-force-network.png": 34667,
	"./blog/graph.png": 72971,
	"./blog/lackImg.png": 49763,
	"./blog/professional-woman-working-night.jpg": 19260,
	"./blog/susan-ava.png": 99500,
	"./core/abstract-ai-brain-vintage-art.jpg": 83989,
	"./core/aiassistant1.jpg": 48199,
	"./core/aiassistant2.jpg": 68216,
	"./core/aiassistant3.jpg": 72533,
	"./core/aiassistant4.jpg": 36910,
	"./core/medical-technology.jpg": 27988,
	"./digital-art-ai-technology.jpg": 35482,
	"./drugomics/0_0-1.jpeg": 42804,
	"./drugomics/3dots.svg": 22281,
	"./drugomics/Chevron left.svg": 92158,
	"./drugomics/Chevrons right.svg": 38472,
	"./drugomics/Clock.svg": 51016,
	"./drugomics/Dollar sign.svg": 47927,
	"./drugomics/Drug Development.png": 65487,
	"./drugomics/Drugomics banner video-small.mp4": 36339,
	"./drugomics/Fibrosis1.png": 10314,
	"./drugomics/Fibrosis2.png": 59297,
	"./drugomics/Fibrosis3.png": 74680,
	"./drugomics/Fibrosis4-1.png": 94705,
	"./drugomics/Fibrosis4-2.png": 18458,
	"./drugomics/Fibrosis4.png": 66199,
	"./drugomics/HE.png": 10095,
	"./drugomics/HE1.png": 85334,
	"./drugomics/HE2.png": 66957,
	"./drugomics/HE3.png": 27012,
	"./drugomics/HE4.png": 8667,
	"./drugomics/OA1.png": 66013,
	"./drugomics/OA2.png": 24774,
	"./drugomics/OA3-1.png": 82905,
	"./drugomics/OA3-2.png": 43170,
	"./drugomics/OA3.png": 63791,
	"./drugomics/OA4-1.png": 43438,
	"./drugomics/OA4-2.png": 62213,
	"./drugomics/OA4.png": 20944,
	"./drugomics/OA5.png": 17849,
	"./drugomics/Pie chart.svg": 1836,
	"./drugomics/SFO.png": 23614,
	"./drugomics/SFO1.png": 25189,
	"./drugomics/SFO2.png": 53390,
	"./drugomics/SFO3.png": 96407,
	"./drugomics/SFO4.png": 4888,
	"./drugomics/Vaccine development.png": 32722,
	"./drugomics/biomedical-engineer.jpg": 83547,
	"./drugomics/biomedical-student-working.jpg": 24553,
	"./drugomics/busy-chef-preparing.jpg": 49707,
	"./drugomics/dna-robot-hand.jpg": 84340,
	"./drugomics/doctor-from-future.jpg": 77948,
	"./drugomics/drug-design-base.png": 79087,
	"./drugomics/drug-design-pill.png": 2321,
	"./drugomics/drug-illustration.png": 94337,
	"./drugomics/drug_1.png": 24020,
	"./drugomics/drugomics.jpg": 60457,
	"./drugomics/focused-female-scientist.jpg": 5191,
	"./drugomics/male-pharmacist.jpg": 39450,
	"./drugomics/medicine-base.png": 66550,
	"./drugomics/medicine-helix.png": 87441,
	"./drugomics/medicine-illustration.png": 86019,
	"./drugomics/medicine_making.jpg": 78532,
	"./drugomics/mission.svg": 48296,
	"./drugomics/partnership.svg": 36678,
	"./drugomics/personalized medicine.png": 24814,
	"./drugomics/pill-shiny.jpg": 86513,
	"./drugomics/portrait-women-lab.jpg": 16928,
	"./drugomics/rocket.svg": 27690,
	"./drugomics/shakehand.svg": 24379,
	"./drugomics/solutions.svg": 32470,
	"./drugomics/vaccine-design-base.png": 46006,
	"./drugomics/vaccine-design-syringe.png": 20450,
	"./drugomics/vaccine-illustration.png": 28030,
	"./drugomics/vaccine_1.jpg": 72545,
	"./drugomics/women-lab-coat.jpeg": 62655,
	"./education/education-cover.png": 65075,
	"./education/education-hero-instructor.png": 95094,
	"./education/education-intro-coaching.png": 39341,
	"./education/education-solution-visual.png": 74108,
	"./education/medical-sensei/case-prep.png": 61595,
	"./education/medical-sensei/debate.png": 90612,
	"./education/medical-sensei/instructor.png": 65838,
	"./education/medical-sensei/reflection.png": 34528,
	"./education/medical-sensei/simulation.png": 98554,
	"./energy/digital-dashboard-monitoring.jpg": 87153,
	"./energy/other_nuclear_fusion.png": 97107,
	"./energy/tree-growing-from-motherboard.jpg": 56978,
	"./finance/NLP.jpg": 84193,
	"./finance/alpha1.png": 90046,
	"./finance/alpha3.png": 92908,
	"./finance/aml.jpg": 38357,
	"./finance/fraud4.png": 81517,
	"./finance/fraudprotection1.jpg": 61139,
	"./finance/futuristic-robot-interacting-with-money.jpg": 39759,
	"./finance/kyc1.jpg": 16219,
	"./finance/kyc2.jpg": 73420,
	"./finance/kyc3.jpg": 11465,
	"./finance/loan1.jpg": 85796,
	"./finance/loan2.jpg": 69491,
	"./finance/loan3.jpg": 14230,
	"./finance/marketintelligence1.jpg": 93669,
	"./finance/marketintelligence2.jpg": 5818,
	"./finance/marketintelligence3.jpg": 76983,
	"./finance/marketintelligence4.jpg": 70668,
	"./finance/personality1-1.png": 28332,
	"./finance/robotic-clerk.jpg": 71343,
	"./finance/trader1.jpg": 31410,
	"./finance/trader2.jpg": 41309,
	"./finance/trader3.jpg": 90176,
	"./finance/trader4.jpg": 73011,
	"./glowing-circuit-board.jpg": 61628,
	"./health/3d-representation-dna.jpg": 22932,
	"./health/Aimma_stage01.png": 57126,
	"./health/Aimma_stage02.png": 24541,
	"./health/Aimma_stage03.png": 3412,
	"./health/Aimma_stage04.png": 95403,
	"./health/Aimma_stage05.png": 31746,
	"./health/CongenitalMe7.jpg": 76318,
	"./health/FutureMe4.jpg": 13316,
	"./health/Get start.svg": 76294,
	"./health/Graphen_6vxx_movie.gif": 93795,
	"./health/How Do I Know.svg": 82712,
	"./health/Step 1 Know Yourself.svg": 72840,
	"./health/Step 2 Personalized Medicine.svg": 52453,
	"./health/Step 3 Stay Supported.svg": 18923,
	"./health/TodayMe.jpg": 15996,
	"./health/aimma-bedside-preview.png": 80656,
	"./health/aimma-doctor/aimma-chronicle-preview.png": 66841,
	"./health/aimma-doctor/aimma-diagnosis-preview.png": 44249,
	"./health/aimma-doctor/aimma-reminder-preview.png": 11704,
	"./health/aimma-doctor/aimma-reporting-preview.png": 11284,
	"./health/aimma-doctor/aimma-triage-preview.png": 77298,
	"./health/aimma-doctor/physician-dashboard-hero.png": 95087,
	"./health/aimma-kiosk-preview.png": 10117,
	"./health/aimma-nurse/aimma-notes-preview.png": 39375,
	"./health/aimma-nurse/nurse-bedside-tablet.png": 44164,
	"./health/aimma-patient/aimma-consult-preview.png": 80396,
	"./health/aimma-patient/aimma-interview-preview.png": 6221,
	"./health/aimma-patient/aimma-patient-hero-backdrop.png": 90596,
	"./health/aimma-patient/aimma-record-preview.png": 97899,
	"./health/aimma-patient/patient-intake-mobile.png": 5214,
	"./health/aimma_ai_powered_healthcare_coordination.png": 73210,
	"./health/aimma_shared_clinical_context_illustration.png": 5743,
	"./health/care-job-scene-with-patient.jpg": 41326,
	"./health/covid-19-viz-032020.jpg": 58229,
	"./health/doctor-from-future-concept.jpg": 48992,
	"./health/doctor-neon-skeleton-cropped.jpg": 18621,
	"./health/doctor-noen-skeleton.jpg": 6119,
	"./health/dot.svg": 32828,
	"./health/ecosystem-delivering-care.png": 12479,
	"./health/ecosystem-managing-orgs.png": 49010,
	"./health/ecosystem-receiving-care.png": 32248,
	"./health/ecosystem-safe-deployment.png": 23939,
	"./health/ecosystem-scaling-ecosystem.png": 90290,
	"./health/ecosystem-teaching-care.png": 78923,
	"./health/freepik__enhance__43990.png": 73342,
	"./health/freepik__expand__62550.png": 57537,
	"./health/freepik__expand__75085.png": 32266,
	"./health/freepik__white-clean-background-a-high-tech-dna-shape-in-bl__95498.mp4": 78918,
	"./health/health3.jpg": 43768,
	"./health/health4.jpg": 90507,
	"./health/healthcare-professionals-discussing-medication.jpg": 56342,
	"./health/image.png": 9802,
	"./health/medical-capsule-with-medical-concept-3d-rendering.jpg": 50897,
	"./health/medical-nurses-working-together-hospital.jpg": 54625,
	"./health/person-being-scanned-by-digital-health-app.jpg": 68509,
	"./health/problem-doctor-fragmented-workflow.png": 93530,
	"./health/solution.svg": 62422,
	"./health/story2.png": 56786,
	"./health/two-men-are-sitting-table-with-monitor-that-says-technology.jpg": 48251,
	"./health/woman-interacting-with-dna.jpg": 50681,
	"./health/zoey-hospital.png": 64967,
	"./icons/ADME Prediction.svg": 69053,
	"./icons/Affinity Prediction.svg": 99670,
	"./icons/Antibody Develoipability.svg": 72631,
	"./icons/Atom Network.svg": 66754,
	"./icons/Biology Networks.svg": 737,
	"./icons/Drug Generation.svg": 81109,
	"./icons/Heredity.svg": 54409,
	"./icons/Joint Injury.svg": 35418,
	"./icons/Molecular Interaction.svg": 34635,
	"./icons/Multi-Omics Analytics.svg": 86814,
	"./icons/Mutation Intelligence.svg": 72991,
	"./icons/Obesity.svg": 61684,
	"./icons/Progress Prediction.svg": 7893,
	"./icons/Protein Function.svg": 53216,
	"./icons/Protein Structure.svg": 52551,
	"./icons/age.svg": 61844,
	"./icons/ai_chip.svg": 96606,
	"./icons/alarm.svg": 63630,
	"./icons/analysis.svg": 7593,
	"./icons/assist.svg": 22978,
	"./icons/bags.svg": 7434,
	"./icons/book.svg": 83952,
	"./icons/cart.svg": 48005,
	"./icons/ch.svg": 58402,
	"./icons/checklist.svg": 66325,
	"./icons/computer.svg": 88288,
	"./icons/conversation.svg": 79002,
	"./icons/cowboy.svg": 35834,
	"./icons/customerSupport.svg": 42004,
	"./icons/discuss.svg": 7123,
	"./icons/dna.svg": 7414,
	"./icons/doctor.svg": 9078,
	"./icons/gene report.svg": 59902,
	"./icons/head.svg": 53721,
	"./icons/hk.svg": 49084,
	"./icons/info.svg": 81271,
	"./icons/joint.svg": 86813,
	"./icons/jp.svg": 68349,
	"./icons/like.svg": 22186,
	"./icons/navigation.svg": 97497,
	"./icons/network.svg": 45191,
	"./icons/pamplet.svg": 49016,
	"./icons/payement_integration.svg": 48111,
	"./icons/payment.svg": 82099,
	"./icons/pill.svg": 48054,
	"./icons/privacy.svg": 8749,
	"./icons/query.svg": 40553,
	"./icons/question.svg": 91767,
	"./icons/sing.svg": 61218,
	"./icons/tw.svg": 36324,
	"./icons/us.svg": 88091,
	"./icons/world.svg": 83017,
	"./logo_drugomic_nav.svg": 74150,
	"./logo_education_nav.svg": 13550,
	"./logo_health_nav.svg": 47262,
	"./logo_name.svg": 9283,
	"./logo_name_light.svg": 82786,
	"./manufacturing/candid-image-photography-with-natural.png": 43323,
	"./manufacturing/energy1.png": 29054,
	"./manufacturing/engineer-controlling-robotic-arm.jpg": 25738,
	"./manufacturing/factory-office-facility-chief-engineer-developer-holds.jpg": 47284,
	"./manufacturing/futurism-perspective-digital-nomads-lifestyle.jpg": 42645,
	"./manufacturing/green1.jpg": 7753,
	"./manufacturing/green2.jpg": 16254,
	"./manufacturing/green3.jpg": 36411,
	"./manufacturing/green4.jpg": 31528,
	"./manufacturing/laptop-with-graph-screen-word-graph-screen.jpg": 17683,
	"./manufacturing/man-is-using-tablet.jpg": 41012,
	"./manufacturing/man-is-working-computer-factory.jpg": 99093,
	"./manufacturing/portrait-engineers-work-hours-job-site-scale.jpg": 63228,
	"./manufacturing/portrait-engineers-work-hours-job-site.jpg": 6709,
	"./manufacturing/smart-warehouse-management-system-with-innovative-internet-things-technology.jpg": 39416,
	"./manufacturing/solar_monitoring_2.png": 10896,
	"./manufacturing/wind-turbine-engineer-reviewing-wind-data-charts-tablet.jpg": 81589,
	"./mobility/ai_car.jpg": 86279,
	"./mobility/aiassistant2.jpg": 50494,
	"./mobility/aiassistant3.jpg": 81979,
	"./mobility/aiassistant4.jpg": 51976,
	"./mobility/aiautomobile.jpg": 60751,
	"./mobility/autozone-overlay.png": 33778,
	"./mobility/car1.jpg": 95693,
	"./mobility/car3.jpg": 18175,
	"./mobility/cardoc2.jpg": 67494,
	"./mobility/cardoc3.jpg": 10627,
	"./mobility/collaboration-certified-engineers-auto-repair-shop-fix-service-broken-vehicle.jpg": 12530,
	"./mobility/man-driving.png": 38854,
	"./mobility/modern-car-futuristic-road.jpg": 95894,
	"./mobility/person-using-ar-technology.jpg": 8341,
	"./newsroom/20200429_6.png": 39163,
	"./newsroom/8clustertable.png": 30917,
	"./newsroom/Digital-Humans-and-Detecting-Disease-at-COMPUTEX-2025.png": 81627,
	"./newsroom/Graphen-Aiia-exhibiton-tw.jpeg": 62399,
	"./newsroom/Untitled.01.png": 32733,
	"./newsroom/ai-indonesia-asech.png": 64611,
	"./newsroom/ai-reward.jpeg": 19026,
	"./newsroom/ai-summit-2022.png": 12174,
	"./newsroom/aml.jpg": 63169,
	"./newsroom/ardi_kf_3.png": 81321,
	"./newsroom/cylin.jpg": 52314,
	"./newsroom/drugomics-debut.jpeg": 29992,
	"./newsroom/genome-force-network.png": 62435,
	"./newsroom/graph-cylin.png": 64669,
	"./newsroom/graphen-drugomics-presentation.jpeg": 65776,
	"./newsroom/hightech-conference-room-with-video-screens.jpg": 95415,
	"./newsroom/info.jpg": 63827,
	"./newsroom/lackImg.png": 92955,
	"./newsroom/mets-taiwan-day-2024.jpg": 86011,
	"./newsroom/whole-graph-0310.png": 75592,
	"./office_meeting_room.jpg": 82396,
	"./people/andrewwang.png": 69318,
	"./people/chenyong.jpg": 55833,
	"./people/chiaowenchen.jpeg": 59653,
	"./people/cylin.jpg": 96559,
	"./people/cylin_square.png": 1413,
	"./people/danielng.jpg": 15884,
	"./people/jerrychen.png": 36510,
	"./people/jessicaliu.jpg": 67720,
	"./people/johnhuang.png": 41100,
	"./people/kinweisoh.jpg": 98273,
	"./people/molalin.jpg": 24452,
	"./people/nathan.jpg": 32422,
	"./people/richardliang.jpg": 90040,
	"./people/tedmaejima.png": 66331,
	"./people/terence.jpg": 55962,
	"./people/tomwang.jpg": 97583,
	"./people/yitingchen.png": 55686,
	"./robotics/AI humanoids mission.png": 35358,
	"./robotics/Book open.svg": 45737,
	"./robotics/Compass.svg": 21800,
	"./robotics/Fast_forward.svg": 58864,
	"./robotics/Frame 3612.png": 59093,
	"./robotics/Globe.svg": 19919,
	"./robotics/Image.svg": 60943,
	"./robotics/Info.svg": 34068,
	"./robotics/Navigation.svg": 16086,
	"./robotics/Search.svg": 14164,
	"./robotics/Shopping cart.svg": 36358,
	"./robotics/Smile.svg": 69036,
	"./robotics/Star.svg": 95912,
	"./robotics/Tag.svg": 90456,
	"./robotics/Thumbs up.svg": 75842,
	"./robotics/Tool.svg": 15310,
	"./robotics/User.svg": 15817,
	"./robotics/Users.svg": 83880,
	"./robotics/Video.svg": 2777,
	"./robotics/agent.png": 75163,
	"./robotics/agents-intro-airport-kiosk.png": 80029,
	"./robotics/agents-why-choose.png": 48335,
	"./robotics/aiia.png": 54318,
	"./robotics/aiia_bg_cashier.png": 57060,
	"./robotics/aiia_frame.png": 26772,
	"./robotics/aiia_machine7.png": 55801,
	"./robotics/aiia_vid.mp4": 21571,
	"./robotics/aiter go.png": 52609,
	"./robotics/aiter one.png": 63055,
	"./robotics/attraction_aiia.png": 5142,
	"./robotics/avatar-lineup.png": 39933,
	"./robotics/black-podium-beneath-canopy-bioluminescent-trees.jpg": 28619,
	"./robotics/brain-robot-small1-1.jpg": 99826,
	"./robotics/building_aiia.png": 30895,
	"./robotics/building_checklist.png": 66227,
	"./robotics/building_video.png": 51442,
	"./robotics/chef.png": 65050,
	"./robotics/close-up-portrait-traveling-woman.jpg": 80732,
	"./robotics/comparison.png": 62861,
	"./robotics/customer-hardware-store-does-select-hammer-tool-showcase.png": 94300,
	"./robotics/daniel.png": 13439,
	"./robotics/elderly-woman-shopping-customer-day.jpg": 27819,
	"./robotics/electronic_aiia.png": 64769,
	"./robotics/electronic_builder.png": 53132,
	"./robotics/electronic_nav.png": 45954,
	"./robotics/electronic_staff.png": 92547,
	"./robotics/exmachina.jpg": 36854,
	"./robotics/freepik__expand__8375.png": 32369,
	"./robotics/furniture_aiia.png": 33863,
	"./robotics/furniture_bundled.png": 21335,
	"./robotics/furniture_image_based.png": 39996,
	"./robotics/furniture_shop.png": 92607,
	"./robotics/furniture_store.png": 32776,
	"./robotics/glenda.png": 52343,
	"./robotics/gordon.png": 44925,
	"./robotics/guest-hotel-is-ringing-bell-reception.jpg": 43131,
	"./robotics/hotel_check_in.png": 59685,
	"./robotics/hotel_facility.png": 97256,
	"./robotics/hotel_info.png": 27195,
	"./robotics/img_classic.png": 85800,
	"./robotics/img_glass.png": 35708,
	"./robotics/img_hologram.png": 77791,
	"./robotics/img_kiosk.png": 82489,
	"./robotics/img_tablet.png": 99902,
	"./robotics/keiji.png": 18,
	"./robotics/kiosk_classic.png": 90656,
	"./robotics/kiosk_frame.png": 31815,
	"./robotics/kiosk_glass.png": 54564,
	"./robotics/kiosk_group.png": 31089,
	"./robotics/kiosk_hologram.png": 29847,
	"./robotics/kiosk_tablet.png": 34102,
	"./robotics/kisok_kiosk.png": 777,
	"./robotics/lab.jpeg": 21746,
	"./robotics/male-executive-analyzing-graphs-digital-tablet-desk-coworking-space.jpg": 37313,
	"./robotics/mutilanguage.png": 85967,
	"./robotics/nav.png": 74695,
	"./robotics/online_order.png": 37442,
	"./robotics/qrcode.png": 22752,
	"./robotics/recommendation.png": 69607,
	"./robotics/recovery.png": 56987,
	"./robotics/restaurant_store.png": 83669,
	"./robotics/robot1.jpg": 46475,
	"./robotics/robot2.png": 32152,
	"./robotics/robot3.png": 16769,
	"./robotics/robotic-figure-with-glowing-orange-accents-contemplating-minimalist-setting-highlights-futuristic-design-advanced-technology.jpg": 9588,
	"./robotics/robotics lab 1.png": 39617,
	"./robotics/robotics lab 2.png": 90634,
	"./robotics/robotics lab 3.png": 45843,
	"./robotics/robotics lab 4.png": 45884,
	"./robotics/robotics lab 5.png": 75301,
	"./robotics/robotics_core_1.jpeg": 86408,
	"./robotics/robotics_core_2.jpeg": 11849,
	"./robotics/robotics_core_3.jpeg": 89634,
	"./robotics/room-with-couch-table-with-plant-it.jpg": 90541,
	"./robotics/sandy.png": 15419,
	"./robotics/store-with-many-items-shelves-including-microwave-toaster.jpg": 57637,
	"./robotics/store1.png": 72038,
	"./robotics/store3.jpg": 34192,
	"./robotics/store5.jpg": 67334,
	"./robotics/store_solution.jpg": 73517,
	"./robotics/story2.png": 55913,
	"./robotics/story3.png": 84736,
	"./robotics/story4.png": 59743,
	"./robotics/supermarket_question.png": 36950,
	"./robotics/supermarket_recipe.png": 14828,
	"./robotics/supermarket_shop.png": 43214,
	"./robotics/supermarket_translate.png": 6986,
	"./robotics/talking-to-aiia.png": 20129,
	"./robotics/trans_ticket.png": 39415,
	"./robotics/trans_trip.png": 86338,
	"./robotics/why robotics.png": 41707,
	"./robotics/zoey.png": 32705,
	"./security/ai_cyber_1.jpg": 90553,
	"./security/ai_cyber_2.jpg": 83438,
	"./security/ai_cyber_4.jpg": 38040,
	"./security/apt1.jpg": 82779,
	"./security/apt2.jpg": 39980,
	"./security/apt4.jpg": 48282,
	"./security/cyber-security-concept-digital-art.jpg": 25267,
	"./security/cybersecurity-green.jpg": 63850,
	"./security/monitoring1.jpg": 70630,
	"./security/monitoring2.jpg": 12049,
	"./security/monitoring3.jpg": 14676,
	"./security/monitoring4.jpg": 35487,
	"./security/security3.jpg": 80172,
	"./there-is-cow-space-suit-floating.png": 70219
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34320;